module.exports = {
  businessNumber: 'Mã nghiệp vụ',
  businessType: 'Loại nghiệp vụ',
  mblNo: 'Số vận đơn chính',
  customer: 'Khách hàng',
  carrier: 'Người vận chuyển',
  vessel: 'Tên tàu',
  shippingCompanyContractNo: 'Số hợp đồng hãng tàu',
  voyageFlight: 'Chuyến bay/Chuyến tàu',
  SeaPortOfLoading: 'Cảng xếp hàng/Cảng khởi hành (cảng biển)',
  portOfDestination: 'Cảng đích',
  dischargingPortCode: 'Cảng dỡ hàng',
  dateOfDeparture: 'Ngày khởi hành',
  businessDate: 'Ngày nghiệp vụ',
  businessReferenceNumber: 'Số tham chiếu nghiệp vụ',
  bookingAgent: 'Đại lý đặt chỗ',
  dateOfCreation: 'Ngày tạo',
  dateOfProof: 'Ngày chứng từ',
  operation: 'Thao tác',
  sales: 'Bán hàng',
  salesDepartment: 'Phòng kinh doanh',
  CustomerService: 'Dịch vụ khách hàng',
  Documents: 'Chứng từ',
  accrued: 'Đã trích lập',
  status: 'Trạng thái',
  actualChargedWeight: 'Trọng lượng tính phí thực tế',
  profit: 'Lợi nhuận',
  totalIncome: 'Tổng doanh thu',
  totalCost: 'Tổng chi phí',
  closingAccountStatus: 'Trạng thái kết chuyển',
  hasReceivable: 'Có bắt buộc kết chuyển không',
  profitExcludingTax: 'Lợi nhuận (chưa thuế)',
  totalIncomeExcludingTax: 'Doanh thu (chưa thuế)',
  totalCostExcludingTax: 'Chi phí (chưa thuế)',
  profitClosingAccount: 'Lợi nhuận chờ kết chuyển',
  totalIncomeClosingAccount: 'Doanh thu chờ kết chuyển',
  totalCostClosingAccount: 'Chi phí chờ kết chuyển',
  hasReceivableTotal: 'Có bắt buộc trích lập không',
  profitCommission: 'Lợi nhuận hoa hồng lần này',
  totalIncomeCommission: 'Doanh thu hoa hồng lần này',
  totalCostCommission: 'Chi phí hoa hồng lần này',
  provisionedStatus: 'Trạng thái trích lập',
  refundCommission: 'Hoa hồng',
  closingAccountRevenue: 'Doanh thu đã kết chuyển',
  closingAccountCost: 'Chi phí đã kết chuyển',
  invoiceCost: 'Chi phí đã nhận hóa đơn',
  payablesWriteOfStatus: 'Trạng thái đối chiếu phải trả',
  receivablesWriteOfStatus: 'Trạng thái đối chiếu phải thu',
  payablesConfirmOfStatus: 'Trạng thái xác nhận chi phí phải trả',
  receivablesConfirmOfStatus: 'Trạng thái xác nhận chi phí phải thu',
  accrualDate: 'Ngày trích lập',
  creator: 'Người tạo nghiệp vụ',
  receivables: 'Phải thu',
  payables: 'Phải trả',
  englishDescriptionOfGoods: 'Tên hàng hóa bằng tiếng Anh',
  chineseDescriptionOfGoods: 'Tên hàng hóa bằng tiếng Trung',
  consignationCompany: 'Đơn vị ủy thác',
  settlementCompany: 'Đơn vị thanh toán',
  destinationAgent: 'Đại lý cảng đích',
  nominatedAgent: 'Đại lý hàng chỉ định',
  destinationAgentShortName: 'Đại lý cảng đích (viết tắt)',
  nominatedAgentShortName: 'Đại lý hàng chỉ định (viết tắt)',
  containerNo: 'Số container',
  amountRange: 'Khoảng tiền',
  profitRange: 'Khoảng lợi nhuận',
  localAmountRange: 'Khoảng tiền quy đổi nội tệ',
  SubmissionDateTime: 'Thời gian nộp',
  AuditDateTime: 'Thời gian kiểm duyệt',
  feeStatus: 'Trạng thái chi phí',
  redChargesOrNot: 'Có điều chỉnh âm không',
  portOfLoading: 'Cảng xếp hàng/Cảng khởi hành',
  AirPortOfLoading: 'Cảng xếp hàng/Cảng khởi hành (hàng không)',
  seaportOfDischarge: 'Cảng dỡ hàng (cảng biển)',
  airportOfDischarge: 'Cảng dỡ hàng (hàng không)',
  airportOfDestination: 'Cảng đích (hàng không)',
  operationDepartment: 'Bộ phận vận hành',
  invoiceDate: 'Ngày lập hóa đơn',
  invoiceDateAR: 'Ngày lập hóa đơn phải thu',
  financialaDate: 'Ngày tài chính',
  solicitationType: 'Loại hình gom hàng',
  warehouseNo: 'Số vào kho',
  itemNo: 'Số dự án',
  receivablesInvoicingStatus: 'Trạng thái hóa đơn',
  receivablesInvoicingStatusAr: 'Trạng thái hóa đơn phải thu',
  businessStatus: 'Trạng thái nghiệp vụ',
  customJobType: 'Loại nghiệp vụ tùy chỉnh',
  separateNumber: 'Số phân đơn',
  containerDescription: 'Mô tả số container',
  designationAgent: 'Đại lý hàng chỉ định',
  masterBLFreightTerm: 'Điều khoản cước chính',
  HBLFreightClause: 'Điều khoản cước phụ',
  IncoTerm: 'Điều khoản thương mại',
  FLCLType: 'Loại hình ghép chuyến',
  SeaExportFLCLType: 'Loại ghép chuyến (xuất biển)',
  SeaImportFLCLType: 'Loại ghép chuyến (nhập biển)',
  OperateType: 'Chế độ vận hành',
  AirExportOperateType: 'Chế độ vận hành (xuất hàng không)',
  AirImportOperateType: 'Chế độ vận hành (nhập hàng không)',
  UserDefinedField1: 'Trường tùy chỉnh 1',
  UserDefinedField2: 'Trường tùy chỉnh 2',
  UserDefinedField3: 'Trường tùy chỉnh 3',
  ManageAuditStatus: 'Tình trạng kiểm tra lợi nhuận',
  paymentRequestNumber: 'Số yêu cầu thanh toán',
  placeOfDelivery: 'Địa điểm giao hàng',
  changeState: 'Tình trạng chỉnh sửa đơn',
  grossProfitRate: 'Tỷ suất lợi nhuận gộp',
  railwayTransportLine: 'Tuyến đường (đường sắt)',
  route: 'Tuyến đường',
  exportLoadingPlan: 'Xuất kế hoạch xếp tấm',
  exportSalesReport: 'Xuất báo cáo bán hàng',
  moreOperations: 'Thao tác khác',
  routeOperation: 'Thao tác tuyến đường',
  completeBooking: 'Hoàn tất đặt chỗ',
  warehousing: 'Nhập kho',
  mountingBoard: 'Xếp tấm',
  pullGood: 'Kéo hàng',
  applicationForFlightAdjustment: 'Yêu cầu điều chỉnh chuyến bay',
  allocateFlights: 'Điều phối chuyến bay',
  confirmCabinAllocation: 'Xác nhận phân bổ khoang',
  cancelConfirmationOfCabinAllocation: 'Hủy xác nhận phân bổ khoang',
  copyIncomingData: 'Sao chép dữ liệu nhập kho',
  otherRemarks: 'Ghi chú khác',
  otherExpenses: 'Chi phí khác',
  delivery: 'Giao hàng',
  deliveryAgent: 'Đại lý giao hàng',
  uploadBoardPhotos: 'Tải lên ảnh xếp tấm',
  subLabel: 'Nhãn phụ',
  prefabricatedMasterOrder: 'Vận đơn chính dự phòng',
  prefabricationOrderSplitting: 'Vận đơn phụ dự phòng',
  printMasterOrder: 'In vận đơn chính',
  printSplit: 'In vận đơn phụ',
  track: 'Theo dõi',
  takeOff: 'Cất cánh',
  arrival: 'Đến cảng',
  Discharge: 'Dỡ tàu',
  billOfLadingInquiry: 'Tra cứu vận đơn',
  expandAll: 'Mở rộng tất cả',
  putItAllAway: 'Thu gọn tất cả',
  noBusinessFlight: 'Chuyến bay không có nghiệp vụ',
  heavy: 'Nặng',
  takeOff2: 'Đã cất cánh',
  arrivedAtPort: 'Đã đến cảng',
  size: 'Kích thước',
  cabinAllocationStatus: 'Tình trạng phân bổ khoang',
  installationInstructions: 'Hướng dẫn xếp tấm',
  photograph: 'Chụp ảnh',
  guanFeng: 'Niêm phong',
  singleCopy: 'Liên đơn',
  flightInformationEmpty: 'Thông tin chuyến bay trống.',
  lockFlight: 'Khóa chuyến bay',
  unlockFlight: 'Mở khóa chuyến bay',
  cabinAllocationStatusConfirmed: 'Trạng thái xếp chỗ của phiếu nghiệp vụ đã được xác nhận chưa?',
  confirmationSucceeded: 'Xác nhận thành công!',
  confirmThis: 'Xác nhận sẽ',
  cabinAllocationStatusUnconfirmed: 'Trạng thái xếp chỗ của phiếu nghiệp vụ được đặt là chưa xác nhận?',
  hair: 'Lông',
  selectBookedOrder: 'Vui lòng chọn đơn đặt chỗ!',
  preprint: 'In trước',
  undoPrinting: 'Hủy in',
  temporaryStorage: 'Tạm lưu',
  bookingNumber: 'Số đặt chỗ',
  bookingTime: 'Thời gian đặt chỗ',
  descriptionOfBookingResults: 'Giải thích kết quả đặt chỗ',
  declared: 'Đã khai báo hải quan',
  enterDeliveryAgent: 'Vui lòng nhập đại lý giao hàng.',
  whetherTakePhotos: 'Có chụp ảnh không?',
  siteRemarks: 'Ghi chú hiện trường',
  otherInstructions: 'Giải thích khác',
  enterBillOfLadingNumber: 'Vui lòng nhập số vận đơn.',
  takeoffTime: 'Thời gian cất cánh',
  deliveryTime: 'Thời gian giao hàng',
  trackingFlight: 'Theo dõi chuyến bay',
  trackingArrival: 'Theo dõi đến cảng',
  trackingDelivery: 'Theo dõi giao hàng',
  enterDepartureTime: 'Vui lòng nhập thời gian cất cánh.',
  enterArrivalTime: 'Vui lòng nhập thời gian đến cảng.',
  enterDeliveryTime: 'Vui lòng nhập thời gian giao hàng.',
  receivingOutsideWarehouse: 'Nhận hàng (kho ngoài)',
  warehousingTime: 'Thời gian nhập kho:',
  damagedAndDamp: 'Có hư hỏng/ẩm ướt',
  photo: 'Ảnh',
  selectPhotos: 'Chọn ảnh',
  deletePhotos: 'Xóa ảnh',
  selectWarehousingDate: 'Vui lòng chọn ngày nhập kho!',
  enterSubLabel: 'Nhập nhãn phụ',
  receiptNo: 'Số phiếu hồi',
  pleaseEnterSubLabel: 'Vui lòng nhập nhãn phụ.',
  uploading: 'Đang tải lên',
  oneFileVolumn2MB: 'Có 1 tệp vượt quá 2MB, không thể tải lên.',
  failedDeleteFile: 'Xóa tệp thất bại!',
  uploadSucceeded: 'Tải lên thành công',
  uploadFailed: 'Tải lên thất bại',
  uploadComplete: 'Tải lên thất bại',
  notExceed6Lines: 'Tối đa không quá 6 dòng!',
  nodeName: 'Tên nút',
  nodeState: 'Trạng thái nút',
  warningLevel: 'Cấp độ cảnh báo',
  warningAt: 'Thời gian cảnh báo',
  line: 'Tuyến đường',
  airTransportArea: 'Khu vực vận chuyển hàng không',
  operationalResponsibilities: 'Trách nhiệm thao tác',
  assignmentOfResponsibilities: 'Phân công trách nhiệm',
  roleList: 'Danh sách vai trò',
  assignedResponsibilities: 'Đã phân công trách nhiệm',
  listOfResponsibilities: 'Danh sách trách nhiệm',
  NoVoucherGeneratedReceivable: 'Chứng từ phải thu chưa tạo',
  NoVoucherGeneratedPayable: 'Chứng từ phải trả chưa tạo',
  VoucherGeneratedReceivable: 'Chứng từ phải thu đã tạo',
  VoucherGeneratedPayable: 'Chứng từ phải trả đã tạo',
  TenTicketsAtTheSameTime: 'Chỉ được xem tối đa 10 nghiệp vụ cùng lúc, vui lòng chọn lại.',
  DataChangedToReopen: 'Dữ liệu đã bị thay đổi, vui lòng mở lại để chỉnh sửa.',
  JobOpenedAndCannotDelete: 'Nghiệp vụ này đã mở trong tab mới, không thể xóa!',
  AreWantToDeleteBusiness: 'Xác nhận xóa nghiệp vụ này?',
  DoToDeleteTheTicket: 'Xóa phiếu nhỏ này?',
  AreToDeleteTheBusiness: 'Xác nhận xóa nghiệp vụ đang chọn?',
  AreToConvertTheItem: 'Xác nhận chuyển đổi mục đang chọn?',
  ConversionSucceeded: 'Chuyển đổi thành công',
  OperationDepartmentCannotBeEmpty: 'Bộ phận xử lý không được để trống!',
  OrangeWorkingDaysFromETA: 'Cam: Trong vòng 7 ngày làm việc đến ETA',
  RedWorkingDaysFromETA: 'Đỏ: Trong vòng 3 ngày làm việc đến ETA',
  BatchOfWholeSplicingType: 'Sửa hàng loạt kiểu ghép chung:',
  UploadedOnlyBeInFormat: 'Chỉ được tải lên file định dạng CSV!',
  ThatSOk: 'Dòng',
  NotInPositiveOperation: 'Không ở trạng thái hoạt động.',
  AreTicketsSubmitted: 'Gửi phiếu này?',
  IsTheTicketPreSubmitted: 'Gửi trước phiếu này?',
  AreWantToWithdrawTicket: 'Xác nhận thu hồi nghiệp vụ này?',
  BillOfLadingInformationTracking: 'Theo dõi thông tin vận đơn',
  PleaseMaintainTheJumpAddress: 'Vui lòng cập nhật địa chỉ chuyển hướng!',
  CannotBeEmpty: 'Không được để trống',
  AreWantToRemoveTicket: 'Xác nhận xóa phiếu nhỏ này?',
  NoBusinessSelected: 'Chưa chọn nghiệp vụ',
  IfForTheGoodsSame: 'Nếu hàng hóa dùng giá ước tính của đại lý hải ngoại cùng hãng tàu, tích vào đây',
  EspeciallyPeersThatUBISpace: 'Chỉ hãng tàu/đối tác mà UBI đặt booking',
  UnitKg: 'Đơn vị: kg',
  UnitCubicMeter: 'Đơn vị: m³',
  UnitTon: 'Đơn vị: tấn',
  DoorNotBeenSavedPrinted: 'Thông tin điểm đến/chưa lưu không thể in!',
  CaseNo: 'Số container:',
  AllTheAssociationDoContinue: 'dữ liệu sẽ bị hủy liên kết, tiếp tục?',
  DetailsSeaborneExportGoodsXls: 'Chi tiết hàng xuất khẩu đường biển.xls',
  FindTheTrailerLocationNow: 'Tra vị trí xe moóc ngay',
  EstimatedLoadingDate: 'Ngày dự kiến xếp hàng',
  SelectDateAndTime: 'Chọn ngày giờ',
  PrimaryDocNoAlreadyExists: 'Số vận đơn chính đã tồn tại',
  PleaseEnterTheFlightNumber: 'Nhập số chuyến bay.',
  PleaseEnterETD: 'Nhập ETD.',
  PleaseEnterAnAction: 'Nhập thao tác.',
  PleaseEnterTheRoute: 'Nhập tuyến đường.',
  AreWantToAllocateFlight: 'Xác nhận điều phối chuyến bay cho {0} nghiệp vụ này?',
  DeploymentSucceeded: 'Điều phối thành công!',
  SuccessfullyPicturesAreYouSave: 'Tải lên thành công: {0} ảnh, thất bại: {1} ảnh. Xác nhận lưu?',
  TheSelectedRecordMustSame: 'ETD của các bản ghi được chọn phải giống nhau!',
  TheSelectedRecordsMustSame: 'Hãng hàng không của các bản ghi được chọn phải giống nhau!',
  PleaseWithTheSameMode: 'Vui lòng chọn nghiệp vụ có chế độ thao tác đồng nhất',
  SiruiPleaseContactTheTroubleshooting: 'Đẩy đơn ủy quyền SIRUI thất bại, vui lòng liên hệ nhân viên kiểm tra:',
  BusinessTodayIsNotCustoms: 'Nghiệp vụ có ngày khai hàng sau hôm nay không được phép hủy',
  G7DataPush: 'Đẩy dữ liệu G7',
  DropDown: 'Kéo xuống',
  TheBeenAddedToOrder: 'Phụ đơn đã được thêm vào chủ đơn!',
  NotBoundYet: 'Chưa liên kết!',
  TheCostSharingAndSeparated: 'Phiếu nhỏ hiện tại có chi phí phân bổ, không thể tách!',
  AreUnbindTheMasterOrder: 'Xác nhận hủy liên kết với chủ phiếu/chủ đơn?',
  PleaseEnterOperatorInformation: 'Vui lòng nhập thông tin người thao tác!',
  TheIsIllegalPleaseEnter: 'Số chủ đơn không hợp lệ, vui lòng nhập lại!',
  PleaseTheDesignatedShippingAgent: 'Vui lòng nhập đại lý hàng hóa chỉ định!',
  TheseWillBeSetJoin: 'Các trường này khác với chủ phiếu, nếu thêm vào sẽ bị đặt giống chủ phiếu. Xác nhận thêm?',
  TheNotExceed6Lines: 'Tối đa không quá 6 dòng!',
  TheNotExceed7Lines: 'Tối đa không quá 7 dòng!',
  ThereMasterTicketThisPerformed: 'Chủ phiếu có chi phí, không thể thực hiện thao tác này!',
  TheTicketIfYouSwitch: 'Phiếu nhỏ đã liên kết với chủ phiếu và chỉ có 1 phiếu nhỏ, nếu chuyển chế độ thì chủ phiếu sẽ bị xóa! Xác nhận chuyển?',
  TheTheBindingRelationshipSwitch: 'Phiếu nhỏ đã liên kết với chủ phiếu, nếu chuyển chế độ sẽ hủy liên kết! Xác nhận chuyển?',
  SwitchAMasterTicketSwitch: 'Chuyển sang chế độ 1 chủ nhiều phụ, hệ thống sẽ tự tạo chủ phiếu liên kết với phiếu hiện tại! Xác nhận chuyển?',
  DateExceededCreditControl: 'Đối tác đã vượt hạn mức kỳ hạn!',
  AmountExceededCreditControl: 'Đối tác đã vượt hạn mức tín dụng!',
  DateAndAmountExceededCreditControl: 'Đối tác đã vượt cả hạn mức và kỳ hạn!',
  ThisHasExceededCreditControl: 'Đối tác này đã vượt kiểm soát tín dụng',
  ItAEntrustingUnitAgent: 'Không thể làm đơn vị ủy quyền hoặc đại lý hàng chỉ định',
  ThisHasBeenAutomaticallyCleared: 'Đã tự động xóa trường này',
  JoinTheTicketSuccessfully: 'Thêm phiếu nhỏ thành công!',
  ThereSplitTicketTheTicket: 'Chủ phiếu hiện chỉ có 1 phụ phiếu, nếu loại bỏ thì chủ phiếu sẽ bị xóa. Xác nhận loại bỏ?',
  TheTicketHasBeenRemoved: 'Chủ phiếu đã bị xóa!',
  AreRemoveThisSubTicket: 'Xác nhận loại bỏ phụ phiếu khỏi chủ phiếu?',
  AttachmentDescription: 'Mô tả tệp đính kèm',
  AirlineCachePleaseResetAgain: 'Không tìm thấy thông tin hãng hàng không trong bộ nhớ đệm, vui lòng đặt lại',
  ResettingTheModifiedContentContinue: 'Đặt lại giá trị ban đầu sẽ ghi đè nội dung đã sửa. Tiếp tục?',
  PleaseEnterTheSplitNumber: 'Vui lòng nhập số phụ đơn',
  AlreadyExists: 'Đã tồn tại!',
  DetailsAirExportGoodsXls: 'Chi tiết hàng xuất khẩu đường hàng không.xls',
  PleaseSelectWarehousingData: 'Vui lòng chọn dữ liệu nhập kho!',
  AreToDeleteThisData: 'Xác nhận xóa dữ liệu nhập kho này?',
  TheRateMAndAdjusted: 'Giá trị TOTAL nhỏ hơn cước M đã thiết lập, không thể điều chỉnh thông tin cước!',
  AirlineInformation: 'Thông tin hãng hàng không',
  PleaseSelectAFee: 'Vui lòng chọn một khoản phí',
  SelectMainOrder: 'Chọn chủ đơn',
  ManualInput: 'Nhập thủ công:',
  TheOrderNumberIsIllegal: 'Số chủ đơn không hợp lệ!',
  WarehousingInstructions: 'Mô tả nhập kho',
  OtherInstructions: 'Ghi chú khác:',
  GoodsIntoThisWarehouse: 'Hàng nhập kho này',
  NeedPhotos: 'Cần ảnh chụp',
  AttachedDocuments: 'Đính kèm tài liệu ngẫu nhiên',
  Generate: 'Tạo',
  Save: 'Có lưu không?',
  PleaseTheEstimatedWarehousingTime: 'Vui lòng nhập thời gian dự kiến nhập kho!',
  AirlineCompany: 'Hãng hàng không:',
  Flight: 'Chuyến bay:',
  FieldOperation: 'Thao tác hiện trường:',
  SendFieldOperation: 'Gửi thao tác hiện trường',
  EntrustedWeight: 'Trọng lượng ủy thác',
  NumberOfBookingPieces: 'Số lượng đặt chỗ',
  BookingWeight: 'Trọng lượng đặt chỗ',
  BookingVolume: 'Thể tích đặt chỗ',
  PleaseFillInTheFlight: 'Vui lòng điền chuyến bay!',
  PromissoryHaveBecomeOfficialBusiness: 'Phiếu này đã là nghiệp vụ chính thức.',
  ThisApprovalStatusAndEdited: 'Đơn này đã vào trạng thái phê duyệt tài chính, không thể chỉnh sửa.',
  AreToConvertTheItem2: 'Xác nhận chuyển đổi mục đã chọn hiện tại?',
  TheDoesNotComplyRules: 'Số vận đơn chính không hợp lệ!',
  DoubleOfLadingHeaderUp: 'Nhấp đôi vào tiêu đề vận đơn để hiển thị',
  SmallNumberOfVotes: 'Số lượng phiếu nhỏ',
  NumberOfPrimaryVotes: 'Số lượng phiếu chính',
  ThePleaseMaintainTheFirst: 'Số vận đơn chính trống, vui lòng cập nhật trước',
  TheTheNewlySelectedContinue: 'Số chuyến bay, hãng hàng không, ngày khởi hành, ngày đến, phương thức giao hàng và điều khoản cước phí của phiếu nhỏ mới chọn không khớp với phiếu chính. Hệ thống sẽ sửa phiếu nhỏ. Tiếp tục?',
  ClickSelectTheGoodsCode: 'Nhấn phím cách để chọn CODE nhóm hàng',
  AreSureVoidThisTicket: 'Xác nhận hủy nghiệp vụ này?',
  AllChargesBeDeleted: 'Tất cả chi phí sẽ bị xóa!',
  SellingPriceCalculationCompleted: 'Hoàn tất tính giá bán',
  OperationOfTicketCannotEdited: 'Bạn không phải người thao tác phiếu này, không thể chỉnh sửa.',
  ActualNotifierCannotBeBlank: 'Người thông báo thực tế không được trống',
  SpecifiedFreightAgentCannotEmpty: 'Đại lý hàng hóa chỉ định không được trống',
  ArrivalDateCannotBlank: 'Ngày đến không được trống',
  OperationDepartmentCannotBlank: 'Bộ phận thao tác không được trống',
  ExpectedArrivalDateCannotBlank: 'Ngày dự kiến đến không được trống',
  PleaseReselect: 'Vui lòng chọn lại',
  EstimatedProfitNotCompanyRegulations: 'Lợi nhuận dự kiến của nghiệp vụ này không nằm trong quy định công ty {0}, xác nhận lưu?',
  ReceivableExpensesMustBeEntered: 'Phải nhập chi phí thu.',
  PayableExpensesMustBeEntered: 'Phải nhập chi phí trả.',
  BlockedCannotUsedContactCustomerManagement: '[{0}] đã bị chặn, không thể sử dụng. Vui lòng liên hệ quản lý khách hàng.',
  CompanyBlockedCannotUsedWithReason: '[{0}] đã bị chặn. Lý do ngừng hoạt động: [{1}].',
  CompanyBlockedCannotUsed: '[{0}] đã bị chặn.',
  exportOption: 'Tùy chọn xuất',
  exportDescription: 'Mô tả xuất',
  dataNotMerged: 'Không hợp nhất dữ liệu',
  noMoreReminders: 'Không nhắc lại',
  UsCustomsClearance: 'Thông quan Mỹ',
  CustomerInformation: 'Tài liệu khách hàng',
  DeclarationMaterials: 'Tài liệu khai báo',
  TopSecretInformation: 'Tài liệu tuyệt mật',
  DeletionIsUnrecoverable: 'Thao tác xóa không thể khôi phục, xác nhận xóa dữ liệu?',
  PleaseEnterOnLine: 'Vui lòng nhập {1} của dòng {0}',
  CustomerName: 'Tên hàng khách hàng',
  CustomsClearanceProductName: 'Tên hàng thông quan',
  NumberOfPackages: 'Số lượng bao bì',
  NumberOfGoods: 'Số lượng kiện hàng',
  CustomsClearanceUnit: 'Đơn vị thông quan',
  Export7501: 'Xuất tờ khai 7501',
  ExportInvoicePackingList: 'Xuất hóa đơn và packing list',
  GenerateReceivableExpense: 'Tạo phí phải thu',
  GeneratePayableExpenses: 'Tạo phí phải trả',
  CopyAsCustomerData: 'Sao chép thành dữ liệu khách hàng',
  CopyAsDeclarationData: 'Sao chép thành dữ liệu khai báo',
  CopyAsTopSecretInformation: 'Sao chép thành dữ liệu tuyệt mật',
  PdfType: 'Loại PDF',
  MergeProductNamesWhenFiles: 'Gộp cùng tên hàng khi tạo file',
  ShowTax: 'Hiển thị thuế',
  ShowChinaSurtax: 'Hiển thị thuế phụ Trung Quốc',
  ShowMargin: 'Hiển thị tiền ký quỹ',
  MarginAmount: 'Số tiền ký quỹ',
  TotalNetWeight: 'Tổng trọng lượng tịnh',
  TotalValue: 'Tổng giá trị hàng',
  TotalTariff: 'Tổng thuế nhập khẩu',
  TotalOtherExpenses: 'Tổng các chi phí khác',
  UnitWeight: 'Trọng lượng đơn vị hàng',
  ItemPricing: 'Đơn giá sản phẩm',
  TotalPriceOfGoods: 'Tổng giá sản phẩm',
  ChinaAdditionalTaxRate: 'Thuế suất phụ Trung Quốc',
  ChinasSurtaxTariff: 'Quy định thuế phụ Trung Quốc',
  ChinaSurtaxClause: 'Điều khoản thuế phụ Trung Quốc',
  AccountsReceivableGeneratedSuccessfully: 'Tạo phí phải thu thành công.',
  PayableExpensesGeneratedSuccessfully: 'Tạo phí phải trả thành công.',
  ThePleaseConfirmWhetherData: 'Thao tác xóa không thể khôi phục, xác nhận xóa dữ liệu?',
  TheSureYouWantData: 'Thao tác xóa không thể khôi phục, xác nhận xóa dòng dữ liệu này?',
  BusinessDateChangedUpdateExchangeRate: 'Ngày nghiệp vụ đã thay đổi, vui lòng cập nhật tỷ giá phí',
  CustomsClearance: 'Thông quan',
  QuantityIsInconsistentOfEqSizeType: '【{eqSize}{eqType}】Số lượng container và thông tin đóng hàng không khớp',
  QuantityIsInconsistentOfCodeType: '【{containerCode}{containerType}】Số lượng container và thông tin xếp pallet không khớp',
  syncChargesToExportJobMessage: 'Đồng bộ {total} thông tin, thành công {successCount}, thất bại {failCount}',
  syncChargesToExportJobFailMessage: '<span>Đồng bộ<span style="color:blue">{total}</span>Chi phí thanh</span>, thành công<span style="color:green">{successCount}</span>, thất bại<span style="color:red">{failCount}</span>\n' +
    '<b>Đây là lý do tại sao</b><br/>',
  ImportReceivablePpayableObjectNotEqualCustomer: 'Phí {no}: Đối tượng thanh toán phí phải thu/trả nhập khẩu != bên xuất khẩu (đơn vị ủy thác)',
  BillGenerated: 'Phí {no}: Đã tạo hóa đơn',
  InvoiceIssued: 'Phí {no}: Đã xuất hóa đơn',
  AccountWrittenOff: 'Phí {no}: Đã đối trừ',
  PaymentApplication: 'Phí {no}: Đã yêu cầu thanh toán',
  ExpenseConfirmationYes: 'Phí {no}: Xác nhận phí - Có',
  ExpenseStatusSubmitted: 'Phí {no}: Trạng thái phí - Đã gửi',
  CollectionAdvancePayment: 'Phí {no}: Đã thu hộ/ứng trước',
  ExpensesGeneratedByVarianceProcessing: 'Phí {no}: Phát sinh từ xử lý chênh lệch',
  Shared: 'Phí {no}: Đã phân bổ',
  NotOperatingCannotSynchronized: 'Đơn hàng không hợp lệ không thể đồng bộ',
  ImportHasSynchronizedDispatchingInformation: '<b style="font-size:16px">Đơn nhập khẩu đã đồng bộ thông tin điều xe</b><br><span style="font-size:16px">Bạn có muốn tiếp tục?</span>',
  MatchingConditionsForPushSOPReceiver: 'Điều kiện khớp người nhận SOP',
  GenerateXChargeSyncRecords: 'Tạo {num} bản ghi đồng bộ phí',
  Density: 'Mật độ',
  CommissionedDensity: 'Mật độ ủy thác',
  ActualDensity: 'Mật độ thực tế',
  EstimatedReviewer: 'Người kiểm tra sơ bộ',
  DateOfPreReview: 'Ngày kiểm tra sơ bộ',
  EnteredXNotMatchAirlineCode: 'Mã chuyến bay nhập {0} không khớp với Airline Code của hãng hàng không',
  EnteredXNotMatchAirlinePrefix: 'Ba chữ số đầu của số vận đơn chính nhập {0} không khớp với MAWB Prefix của hãng hàng không',
  HasPackingFeeEnterWarehouse: 'Có phí đóng hàng, vui lòng nhập thông tin kho!',
  SuccessSyncInfo: 'Đồng bộ thông tin thành công',
  Search: 'Truy vấn',
  Clear: 'Xóa trống',
  ShipperName: 'Tên người gửi hàng',
  ConsigneeName: 'Tên người nhận hàng',
  NotifyPartyName: 'Tên người thông báo',
  AfterToBeRevokedSynchronize: 'Sau khi xác nhận đồng bộ sẽ không được hủy, bạn có chắc chắn đồng bộ?',
  PleaseADataToDelete: 'Vui lòng chọn một dữ liệu để xóa!',
  CreatePaymentRequestSelectFee: 'Tạo yêu cầu thanh toán - Chọn chi phí',
  PleaseSelectTheBill: 'Vui lòng chọn hóa đơn.',
  YouViewOrPrintOthers: 'Bạn không có quyền xem tệp người khác tải lên hoặc in.',
  AgentCommissionBill: 'Hóa đơn chia phần đại lý',
  TheWithdrawnAndCannotOperated: 'Nghiệp vụ đã hủy thông quan, không thể thao tác',
  PleaseSelectTheForeignBill: 'Vui lòng chọn hóa đơn nước ngoài.',
  Equivalent: 'Quy đổi',
  EquivalentToRMB: 'Quy đổi RMB',
  OperationFailed: 'Thao tác thất bại',
  FrontEndErrorCallbackFailed: 'Lỗi frontend: Gọi lại thất bại',
  YouToEditTheAdministrator: 'Bạn không có quyền chỉnh sửa dữ liệu, vui lòng liên hệ quản trị viên',
  UploadingPleaseWait: 'Đang tải lên, vui lòng đợi......',
  AssociateBusinessSOPNode: 'Nút SOP nghiệp vụ liên quan',
  CustomsDuty: 'Thuế quan',
  AddAmendmentFee: 'Thêm phí sửa đơn',
  AddNewBusiness: 'Thêm nghiệp vụ',
  Add: 'Thêm mới',
  Maintain: 'Giữ nguyên',
  Modify: 'Chỉnh sửa',
  PleaseEnterTheBusinessNumber: 'Vui lòng nhập số nghiệp vụ!',
  ReceiptSuccessful: 'Nhận biên lai thành công',
  WaitingForReceipt: 'Đợi biên lai',
  SaveSuccessfully: 'Lưu thành công',
  SendEmail: 'Gửi email',
  SystemEmail: 'Email hệ thống',
  CompanyEmail: 'Email công ty',
  PersonalEmail: 'Email cá nhân',
  Submitted: 'Đã nộp',
  DataSource: 'Nguồn dữ liệu',
  SystemInput: 'Nhập liệu hệ thống',
  PortAreaData: 'Dữ liệu cảng',
  UpdateToPortAreaData: 'Cập nhật thành dữ liệu cảng',
  NewExportClearancePolicy: 'Quy định mới về thông quan xuất khẩu',
  YangshanAreaNovember152021: 'Khu vực hải quan Dương Sơn: 15/11/2021',
  WaigaoqiaoAreaNovember222021: 'Khu vực hải quan cảng ngoài: 22/11/2021',
  GarbageManifest: 'Danh sách hàng rác',
  N1OnceTheManifestManifest: '1. Danh sách hàng rác bị hải quan nghiêm cấm! Theo quy định hải quan, mỗi danh sách đặt chỗ trước phải tương ứng với một lô hàng xuất thực tế. Sau khi gửi danh sách, nếu hàng hóa của bạn không được xuất (do trễ tàu, thay đổi kế hoạch xuất hàng...), danh sách đó sẽ bị coi là danh sách hàng rác!',
  N2ManifestMustBeDeletion: '2. Ví dụ về danh sách hàng rác: Sau khi thay đổi tàu, phải xóa danh sách đặt chỗ cũ trước khi gửi danh sách mới!',
  N3YuanOnTheManifest: '3. Hậu quả nếu không xóa danh sách hàng rác: Không chỉ ảnh hưởng xếp tàu, hải quan có thể phạt đại lý tối đa 50.000 tệ và thu hồi giấy phép khai báo! Khi phát sinh danh sách hàng rác, hãy liên hệ CSKH để được hỗ trợ xóa ngay!',
  BusinessUUIDCannotBeEmpty: 'UUID nghiệp vụ không được để trống!',
  BillUUIDCannotBeEmpty: 'UUID hóa đơn không được để trống!',
  FileInformation: 'Thông tin tệp',
  BillingInformation: 'Thông tin hóa đơn',
  DomesticWarehouse: 'Kho nội địa',
  ForeignWarehouse: 'Kho nước ngoài',
  ExpectedTimeAtAmazonWarehouse: 'Thời gian dự kiến nhập kho Amazon',
  ReferenceBoxNumber: 'Số tham chiếu container',
  TotalDoesNotEqualCost: 'Tổng chi phí phân bổ hóa đơn nhỏ không khớp với chi phí gốc!',
  NameCannotBeEmpty: 'Tên không được để trống!',
  SOPOperationStatus: 'Trạng thái thao tác SOP',
  AddSpecialFees: 'Thêm chi phí đặc biệt',
  TrailerTrackingUsageNotice: 'Thông báo sử dụng theo dõi xe kéo',
  N1SituationIncludingButDepartments: '1. Theo luật pháp, hệ thống có nghĩa vụ ghi nhận hoạt động tra cứu (bao gồm nhưng không giới hạn: biển số xe, người tra cứu, thời gian) để cung cấp bằng chứng khi cơ quan chức năng yêu cầu.',
  N2ConsentBeforeQueryingCommunication: '2. Theo luật, phải được chủ xe đồng ý trước khi tra cứu vị trí. Người dùng cần xin ủy quyền để tránh vi phạm pháp luật.',
  N3TheOwnersConsentConsequences: '3. Nếu tra cứu thông tin xe không được phép, người dùng phải tự chịu trách nhiệm pháp lý.',
  N4ItToIrrelevantUser: '4. Khi đã được ủy quyền, chỉ sử dụng thông tin trong phạm vi cho phép. Tiết lộ cho bên thứ ba không liên quan sẽ phải chịu trách nhiệm pháp lý.',
  N5SystemCannotGuaranteeResponsibility: '5. Do yếu tố khách quan (như lỗi thiết bị GPS), hệ thống không đảm bảo độ chính xác tuyệt đối. Người dùng cần hiểu rõ hệ thống không chịu trách nhiệm về kết quả tra cứu.',
  N6BeAwareOfHome: '6. Dịch vụ hiện hợp tác với bên thứ ba (Vịt mỏ rộng), việc sử dụng đồng nghĩa cho phép họ liên hệ với bạn. Đây không phải do CargoWare/Wòlián rò rỉ thông tin.',
  DoNotRemindMeAgain: 'Lần sau không nhắc lại',
  IUnderstoodAndConfirmContinuing: 'Tôi đã hiểu, xác nhận tiếp tục',
  ImportModeTip: 'Các loại nhập khẩu là sửa đổi, hệ thống lần lượt căn cứ vào số đóng cửa, số hộp, số niêm phong, loại hộp, loại hộp hộp giúp bạn phù hợp với dữ liệu nhất trí với khu vực cảng biển.\n' +
    'Loại nhập để giữ, dữ liệu nhập cho bạn không khớp với dữ liệu cảng, tức là dữ liệu nhập ban đầu cho bạn.',
  NewExportClearancePolicyTip: 'Lệnh 172 Hải quan Thượng Hải thay đổi điều kiện thông quan: thông tin thông quan sẽ được truyền tải qua biên lai "Danh sách xếp tàu". Khách hàng cần theo dõi trạng thái danh sách sau khi khai báo, liên hệ CSKH nếu có bất thường. Các trường hợp ảnh hưởng xếp tàu: không xóa danh sách thừa trong LCL, giao hàng trễ, ghép hàng không đúng quy cách sau thông quan, sửa danh sách không thành công, trùng lặp số vận đơn trong 2 năm. Sau khi nhận biên lai danh sách xếp tàu, nếu cần sửa/xóa/thêm danh sách đặt chỗ, phải liên hệ đại lý tàu xóa danh sách xếp tàu trước.',
  Upload0UploadFailed0: 'Tải lên thành công: {0}, thất bại: {1}.',
  CustomerBranchScopeNot: '【Đơn vị ủy thác】 không thuộc chi nhánh chính xác, vui lòng chọn lại cho khớp.',
  BatchInitiateCollaboration: 'Khởi tạo hợp tác hàng loạt',
  OrderCenterBranchNotAvailable: '{0} là chi nhánh tiếp nhận nhưng chưa bật cấu hình',
  BatchCollaboration: 'Hợp tác hàng loạt',
  SuccessCooperateX: 'Hợp tác thành công {0} nghiệp vụ',
  SuccessCooperateXFailY: 'Thành công {0} nghiệp vụ, thất bại {1}. Lý do:',
  BusinessIsMaster: 'Nghiệp vụ {0} là vận đơn chính',
  NotBranchCollaborationManageme: 'Nghiệp vụ {0} không thuộc chi nhánh tiếp nhận và không có quyền quản lý hợp tác',
  OpOfficeNotCooperateBranch: 'Công ty xử lý nghiệp vụ {0} không thể là chi nhánh hợp tác',
  ExistCollaborationBranchRecord: 'Nghiệp vụ {0} đã có bản ghi hợp tác với chi nhánh nhận {1}',
  EntrustedRecipient: 'Người nhận ủy thác',
  NoteConsigneeCustomerExportImport: 'Lưu ý: Khi "Người nhận" xuất khẩu trùng với "Đơn vị ủy thác" nhập khẩu, phải đảm bảo đối tác này có vai trò "Khách hàng"!!',
  SetAsDefaultExportInfo: 'Đặt nội dung này làm thông tin chuyển tiếp xuất khẩu mặc định',
  RecipientNotExist: 'Người nhận hiện tại không tồn tại',
  ConsigneeCustomerNotExist: 'Người nhận hiện tại không có vai trò "Khách hàng", không thể dùng làm đơn vị ủy thác. Vui lòng cập nhật thông tin đối tác trước khi thử lại.',
  CurrencyChangeCheckDiff: 'Điều chỉnh trường Currency: {0}. Lưu ý số thập phân cho các mục 【Prepaid】【Collect】 và 【Other Charge】.',
  InvalidBillCannotConfirm: 'Không thể xác nhận hóa đơn đã hủy, vui lòng kiểm tra',
  Reviewed: 'Đã kiểm tra',
  ApplicationPayInitiated: 'Đã gửi yêu cầu thanh toán',
  NotPrintedState: 'Không ở trạng thái đã in',
  StatementGenerated: 'Đã tạo bảng đối chiếu',
  NotUnapproved: 'Không ở trạng thái chờ phê duyệt',
  BillCannotVoid: '{0} hóa đơn {1} không thể hủy bỏ, vui lòng xác nhận',
  SwitchHQNotView: 'Bạn đã chuyển sang chi nhánh HQ nhưng không có quyền xem trang chi tiết, vui lòng quay lại trang danh sách để tra cứu lại',
  JumpListPage: 'Chuyển đến trang danh sách',
  WhenDepartmentBranchNewSelection: 'Khi phòng ban/chi nhánh của nhân viên bán hàng/chứng từ/dịch vụ khách hàng không khớp với chứng từ gốc, cần chọn lại!',
  OneClickQuery: 'Tra cứu nhanh',
  PreSubimtCheckTip: 'Lưu ý: Sau khi gửi trước nghiệp vụ sẽ không thể chỉnh sửa. Sau khi tất cả đơn hàng được gửi đi, có thể sử dụng nút "Tra cứu nhanh" bên dưới để kiểm tra đơn hàng thất bại.',
  SubimtCheckTip: 'Lưu ý: Sau khi gửi nghiệp vụ sẽ không thể chỉnh sửa. Sau khi tất cả đơn hàng được gửi đi, có thể sử dụng nút "Tra cứu nhanh" bên dưới để kiểm tra đơn hàng thất bại.',
  FinanceAuditCheckTip: 'Lưu ý: Sau khi duyệt nghiệp vụ sẽ không thể chỉnh sửa. Sau khi tất cả đơn hàng được duyệt, có thể sử dụng nút "Tra cứu nhanh" bên dưới để kiểm tra đơn hàng thất bại.',
  SalesMapping: 'Ánh xạ bán hàng:',
  SalesCargoSalesMap: 'Ánh xạ bán hàng nghiệp vụ ủy thác sang nhân viên bán hàng vận chuyển của nghiệp vụ thao tác',
  BusinessRemarks: 'Ghi chú nghiệp vụ',
  InternalEquipmentNote: 'Ghi chú nội trang',
  QuantityWeightCubageConfirmed: 'Đã xác nhận số kiện/trọng lượng/thể tích',
  DataModifiedHasMergeContinueSave: 'Dữ liệu đã được [{0}] chỉnh sửa vào {1}, hệ thống đã hợp nhất giúp bạn, có lưu lại không?',
  SyncYongYouNotCancelReview: 'Đã đẩy sang hệ thống UFIDA, không thể hủy duyệt',
  PrintByBusinessNumber: 'In theo mã nghiệp vụ',
  SelectNotBelongToCurBranch: 'Trong các chứng từ đã chọn có chứng từ nghiệp vụ không thuộc chi nhánh hiện tại, không thể chỉnh sửa!',
  ClickFilePrivew: 'Nhấp vào tên file để xem trước',
  PackageDownload: 'Tải xuống dạng nén',
  CCPost: 'Vị trí CC',
  CCYourself: 'CC cho bản thân',
  SaveCcAddresNextDefault: 'Lưu vị trí CC lần này (sẽ tự động hiển thị cho lần sau)',
  ForMakingBatchTransferModifications: 'Mã nghiệp vụ {0} chỉ chọn thông tin phụ mà không chọn thông tin chính, không thể chuyển tàu hàng loạt, vui lòng chọn thông tin chính tương ứng để chỉnh sửa',
  TherePositionPleaseConfirmSuitable: '<b>{0}</b> vị trí có nhiều lựa chọn khả dụng, vui lòng xác nhận nhân viên hiện tại đã phù hợp.',
  TheWithBusinessStandardsSelection: '<b>{0}</b> vị trí không phù hợp quy chuẩn nghiệp vụ, vui lòng chọn lại.',
  PositionReSelectionReminder: 'Nhắc nhở chọn lại vị trí',
  LastEmailSentTime: 'Thời gian gửi email cuối cùng',
  FeeReceivable: 'Chi phí (phải thu)',
  CostsPayable: 'Chi phí (phải trả)',
  ListOfHazardousMaterials: 'Danh sách hàng hóa nguy hiểm',
  DangerousGoodsInformation: 'Thông tin hàng hóa nguy hiểm',
  CustomsProcedures: 'Các thủ tục hải quan',
  CarDispatchInformation: 'Thông tin phân bổ xe',
  QuantityGrossWeightVolume: 'Số lượng/Tổng trọng lượng/Thể tích',
  CustomFormBusinessBooking: 'Form tùy chỉnh (đặt hàng kinh doanh)',
  BusinessOperationInstruction: '[Lệnh vận hành nghiệp vụ]',
  NonEditable: 'Không thể chỉnh sửa',
  BatchExportToImport: 'Xuất khẩu lô hàng sang nhập khẩu',
  NonSupportImportationThroughEntry: 'Các công ty không thuộc tập đoàn không hỗ trợ nhập khẩu qua xuất khẩu tái nhập.',
  BatchProcessingForTheReselect: 'Chuyển đổi xuất khẩu sang nhập khẩu theo lô chỉ hỗ trợ thao tác hàng loạt cho cùng một dịch vụ đại lý cảng đích. Vui lòng chọn lại!!',
  TheNotMeetTheConversion: 'Đại diện cảng đích và công ty vận hành không đáp ứng điều kiện chuyển từ xuất khẩu sang nhập khẩu!',
  TheThePortAgentExist: 'Chi nhánh kết nối của đại diện cảng đích không tồn tại.',
  NotForReExport: 'Không được xuất khẩu rồi nhập khẩu lại',
  ExportFunctionIsNotEnabled: 'Chức năng xuất khẩu sang nhập khẩu chưa được bật',
  BatchProgressPleaseReferBelow: 'Quy trình xuất khẩu hàng loạt sang nhập khẩu đang được thực hiện. Vui lòng xem kết quả thực hiện bên dưới!',
  TheDestinationPortAgentEmpty: 'Chi nhánh kết nối của đại diện cảng đến không được để trống!',
  PleaseAFeeToEdit: 'Vui lòng chọn một khoản phí để chỉnh sửa',
  PleaseFeesYouWantDelete: 'Vui lòng chọn khoản phí cần xóa!',
  AreWantToDeleteExpense: 'Bạn có chắc chắn muốn xóa khoản chi phí đã chọn không?',
  ThisFeeIsNotEditable: 'Phí này không thể chỉnh sửa.',
  TheNameCannotBeEmpty: 'Tên phí không được để trống.',
  BillUpTo3Currencies: 'Hóa đơn hỗ trợ tối đa 3 loại tiền tệ!'
}
